var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 158,
    viewBox: "0 0 124 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2292 83.5C100.5 77.5 121.5 45 124 0V149C124 153.418 120.478 157.005 116.06 157.011C88.6761 157.052 0.571416 157.182 0.999971 157C20.9996 148.5 28.7292 148.5 52.2292 132C58.4182 127.655 68.2973 119.929 76.4999 111C86.9745 99.598 95.3949 86.865 97.2292 83.5Z",
    fill: "#C1D4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetKm);
export default __webpack_public_path__ + "static/media/getKM.a97003c026d2ea6a4e12ed200c2eb0b5.svg";
export { ForwardRef as ReactComponent };